import { dark } from "@mui/material/styles/createPalette";

const colors = {

  primary: "#556cd6", // blue
  secondary: "#81c784", // Light green
  textPrimary: "#333", // Dark gray
  white: "#FFFFFF", // White
  error: "#f44336", // Red
  lightGray: "#f9f9f9",
  darkGray: "#333",
};
  
export default colors;  